export const getPropertyNameWithShortAddress = (property, address) => {
  return `${
    property?.name && property.name !== address?.address1
      ? `${property.name}, `
      : ""
  }${address?.address1} ${address?.address2} ${address?.city} ${
    address?.state_or_province
  }`;
};

export const getPropertyNameWithLongAddress = (property, address) => {
  return `${
    property?.name && property.name !== address?.address1
      ? `${property.name}, `
      : ""
  }${address.address1}, ${address.city}, ${address.state_or_province} ${
    address.postal_code
  }`;
};

export const getShortAddressFromAddress = (address) => {
  return `${address?.address1}, ${address?.city}, ${address?.state_or_province} ${address?.postal_code}`;
};

export const googlePlaceToAddress = (place) => {
  if (!place.address_components) return null;

  const fields = {};
  const streetAndRoute = ["", ""];
  place.address_components.forEach((c) => {
    c.types.forEach((t) => {
      if (t === "street_number") streetAndRoute[0] = c.long_name;
      else if (t === "route") streetAndRoute[1] = c.short_name;
      else if (t === "locality") fields.city = c.long_name;
      else if ((t === "sublocality" || t === "political") && !fields.city)
        // In some cases, like NYC with its 5 boroughs, there is no locality.
        // Brooklyn is the sublocality, no locality or city-like thing shows up
        // (King Country is the county, Carroll Gardens a neighborhood, for example).
        // So use this as the best we can, it should usually be good enough
        // for geocoding purposes (not too specific or generic).
        fields.city = c.long_name;
      else if (t === "administrative_area_level_1")
        fields.stateOrProvince = c.short_name;
      else if (t === "country") fields.country = c.short_name;
      else if (t === "postal_code") fields.postalCode = c.long_name;
    });
  });
  fields.isPrecise = Boolean(streetAndRoute[0] && streetAndRoute[1]);
  fields.address1 = streetAndRoute.filter(Boolean).join(" ");

  return fields;
};
